export default __webpack_public_path__ + "static/media/a5.26c06a16.svg";